module.exports = __webpack_public_path__ + "static/media/angle-down.16655c03.svg";